<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <client-select :model="filterFormModel" attribute="client" @input="load" class="mr-1"></client-select>
          <time-range-picker ref="timeRangePicker" :model="filterFormModel" @input="load" :label="$t('time')"
                             :default-shortcut="3" class="mr-1"></time-range-picker>
          <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1">Reset</button>
        </div>
      </div>
      <div v-if="data.length === 0" class="tile text-center text-danger">{{ $t('noData') }}</div>
      <div v-else>
        <div class="tile">
          <div class="row">
            <div class="col">
              <div>
                <apexchart :height="350" :options="chartOptions" :series="chartData"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="tile">
          <div class="table-responsive c-template-table">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th></th>
                <th></th>
                <th class="text-center">{{ $t('quantityUsed') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr class="bg-success">
                <td></td>
                <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
                <td class="text-center">{{ sum.totalCount | numFormat }}</td>
              </tr>
              <tr class="bg-warning">
                <td></td>
                <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                <td class="text-center">{{ avg.totalCount | numFormat }}</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td class="text-center">{{ index + 1 }}</td>
                <td><b>{{ item.clientDomain || $t('unknown') }}</b></td>
                <td class="text-center">{{ (item.totalCount || 0) | numFormat }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeRangePicker from "@/components/TimeRangePicker";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts';
import ClientSelect from "@/components/ClientSelect.vue";

export default {
  components: {ClientSelect, TimeRangePicker, 'apexchart': VueApexCharts},
  data: function () {
    return {
      filterFormModel: {
        client: null,
      },
      loading: true,
      data: [],
      chartOptions: {
        xaxis: {},
        chart: {
          zoom: {
            enabled: false
          },
          type: 'bar'
        }
      },
      chartData: [],
      sum: {},
      avg: {},
    }
  },
  methods: {
    generateRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    load() {
      this.data = []
      let loader = this.$loading.show();
      this.loading = true;
      if (!this.filterFormModel.to || !this.filterFormModel.from) {
        this.filterFormModel.from = moment().startOf('month').format('x');
        this.filterFormModel.to = moment().endOf('month').format('x');
      }
      this.$service.get('/report-usage/activity-level', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data;
        this.sum = {};
        this.avg = {};
        this.data.forEach(item => {
          for (let key in item) {
            if (!['_id', 'clientDomain'].includes(key)) {
              item[key] = Math.abs(item[key]);
              if (!this.sum[key]) {
                this.sum[key] = 0;
              }
              this.sum[key] += Math.abs(item[key]);
            }
          }
        });
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length);
        }

        const baseColors = ['#FF4560', '#008FFB', '#00E396', '#FEB019', '#775DD0', '#546E7A', '#26A69A', '#D10CE8'];
        const colors = this.data.map((_, index) => {
          if (index < baseColors.length) {
            return baseColors[index];
          } else {
            return this.generateRandomColor();
          }
        });
        this.chartOptions = {
          chart: {
            type: 'bar',
            zoom: {enabled: false},
          },
          dataLabels: {
            enabled: true,
            offsetX: -6,
            style: {fontSize: '12px', colors: ['#fff']},
            formatter: val => new Intl.NumberFormat().format(val)
          },
          plotOptions: {
            bar: {horizontal: false, distributed: true},
          },
          colors: colors,
          yaxis: {
            tooltip: {enabled: false}
          },
          xaxis: {
            categories: this.data.map(item => item.clientDomain || this.$t('unknown'))
          }
        };

        this.chartData = [{
          name: this.$t('quantityUsed'),
          data: this.data.map(item => item.totalCount || 0)
        }]
      }).finally(() => {
        loader.hide();
        this.loading = false;
      });
    },
    reset() {
      this.filterFormModel = {
        client: null,
      };
      this.load()
    },
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        unknown: 'Unknown',
        totals: 'Total',
        noData: 'No data!',
        quantityUsed: 'Number of times used',
      },
      vi: {
        unknown: 'Chưa rõ',
        totals: 'Tổng',
        noData: 'Không có dữ liệu!',
        quantityUsed: 'Lượt sử dụng',
      }
    }
  }
}
</script>